<template>

    <div class="w-full">
        <h4 class="mb-3">EPG Providers</h4>

        <vs-button color="success" icon-pack="feather" icon="icon-plus-circle" class="mb-3" @click="addEPGProviderPrompt = true">Add</vs-button>

        <vx-card id="providersDiv"  class="vs-con-loading__container mb-6">

            <vs-table ref="table" @selected="openEPGProvider" :data="tableData" class="mt-3" pagination search :maxItems="itemsPerPage">
                <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                    <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4" v-if="tableData.length > 0">
                        <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ tableItems - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : tableItems }} of {{ tableItems }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>

                        <vs-dropdown-menu>

                            <vs-dropdown-item @click="itemsPerPage=10">
                                <span>10</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=20">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=50">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=100">
                                <span>100</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=250">
                                <span>250</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=500">
                                <span>500</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=1000">
                                <span>1000</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>

                <template slot="thead">
                    <vs-th sort-key="name">Name</vs-th>
                    <vs-th sort-key="epg_type">EPG Type</vs-th>
                    <vs-th sort-key="update_interval">Update interval</vs-th>
                    <vs-th sort-key="last_update">Last update</vs-th>
                    <vs-th sort-key="last_entry">Last entry</vs-th>
                    <vs-th sort-key="channels_used">Channels used</vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                        <vs-td :data="data[index].name">
                            {{ data[index].name }}
                        </vs-td>

                        <vs-td :data="data[index].epg_type">
                            <p v-if="data[index].epg_type === 0">XML File</p>
                            <p v-else-if="data[index].epg_type === 1">GZipped XML File</p>
                        </vs-td>

                        <vs-td :data="data[index].update_interval">
                            {{ data[index].update_interval }}
                        </vs-td>

                        <vs-td :data="data[index].last_update">
                            <p v-if="!data[index].update_in_progress">
                                {{ moment(data[index].last_update).format('YYYY/MM/DD HH:mm:ss') }}
                            </p>
                            <vs-chip v-else color="primary">Update in progress</vs-chip>

                        </vs-td>

                        <vs-td :data="data[index].last_entry">
                            {{ moment(data[index].last_entry).format('YYYY/MM/DD HH:mm') }}
                        </vs-td>

                        <vs-td :data="data[index].channels_used">
                            {{ data[index].channels_used }}
                        </vs-td>

                    </vs-tr>
                </template>
            </vs-table>
        </vx-card>

        <e-p-g-provider-channels :provider-name-column="true" :url="'/api/management/v1/epg_provider_channels'"/>

        <vs-popup title="Add EPG provider" :active.sync="addEPGProviderPrompt">
            <div id="addProviderDiv" class="vs-con-loading__container" >
                <p class="mt-6">Name</p>
                <vs-input v-model="addObject['name']" class="w-full"></vs-input>
                <p class="mt-6">Update interval in minutes</p>
                <vs-input v-model="addObject['update_interval']" class="w-full"></vs-input>
                <p class="mt-6">EPG Type</p>
                <vs-select autocomplete class="w-full" v-model="addObject['epg_type']">
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in [{id: 0, name: 'XML File'}, {id: 1, name: 'GZipped XML File'}, {id: 2, name: 'XML in tar.gz'}, {id: 3, name: 'XML in zip'}]" />
                </vs-select>
                <p class="mt-6">URL</p>
                <vs-input v-model="addObject['url']" class="w-full"></vs-input>
                <vs-divider/>
                <vs-button color="success" class="mt-6; mr-1" @click="addEPGProvider">Add</vs-button>
            </div>
        </vs-popup>

    </div>

</template>
<script>

    import EPGProviderChannels from './EPGProviderChannels'

    export default {
        components: { EPGProviderChannels },
        data() {
            return {

                itemsPerPage: 100,
                isMounted: false,

                providers: [],

                addObject: {},
                addEPGProviderPrompt: false

            }
        },
        methods: {
            loadData() {
                this.$vs.loading({
                    container: '#providersDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/epg_provider/')
                loadPromise.then(function(response) {
                    thisIns.providers = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#providersDiv > .con-vs-loading')
                })
            },
            addEPGProvider() {
                this.$vs.loading({
                    container: '#addProviderDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this

                const addPromise = this.$http.post('/api/management/v1/epg_provider/', {
                    name: this.addObject.name,
                    url: this.addObject.url,
                    epg_type: Number(this.addObject.epg_type),
                    update_interval: Number(this.addObject.update_interval)
                })

                addPromise.then(function(response) {
                    thisIns.addEPGProviderPrompt = false
                    thisIns.$printSuccess('EPG Provider added')
                    thisIns.$nextTick(() => {
                        thisIns.$router.push('/epg_provider/' + response.data)
                    })
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#addProviderDiv > .con-vs-loading')
                })
            },
            openEPGProvider(tr) {
                this.$router.push('/epg_provider/' + tr.id)
            }
        },
        computed: {
            currentPage() {
                if (this.isMounted) {
                    return this.$refs.table.currentx
                }
                return 0
            },
            tableItems() {
                if (this.isMounted) {
                    return this.$refs.table.queriedResults.length
                }
                return 0
            },
            tableData() {
                return this.providers
            }
        },
        mounted() {
            this.isMounted = true
            this.loadData()
        }
    }

</script>
